import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import { kkTranslations, ruTranslations } from './locales'
import kkForensics from './locales/kk/forensics.json'
import ruForensics from './locales/ru/forensics.json'

// Add json translations into OzLiveness
const OzLiveness = window.OzLiveness
OzLiveness?.add_lang('ru', ruForensics)
OzLiveness?.add_lang('kk', kkForensics)

const storedLang = localStorage.getItem('i18nextLng')

if (!storedLang) localStorage.setItem('i18nextLng', 'ru')

export const resources = {
  kk: kkTranslations,
  ru: ruTranslations
} as const

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      lookupQuerystring: 'lang'
    },
    resources,
    ns: ['main', 'common', 'landing', 'footer'],
    defaultNS: 'main',
    interpolation: {
      escapeValue: false
    }
  })

i18n.languages = ['kk', 'ru']

export default i18n
